import { hexToUint8Array, toHex } from '@pactswap/cwap-cm-lib/shared';
import { encodeAddress, getAddressEncoding } from './utils';
export const encodeL1TxPayload = (params) => {
    const results = [];
    if ('preset' in params) {
        const presetId = hexToUint8Array(toHex(Number.MAX_SAFE_INTEGER - params.preset));
        const minL1AmountHex = BigInt(params.minL1Amount).toString(16);
        const promisedL1AmountHex = BigInt(params.promisedL1Amount).toString(16);
        const minL1Amount = hexToUint8Array(minL1AmountHex);
        const promisedAmount = hexToUint8Array(promisedL1AmountHex);
        results.push(presetId.byteLength, ...presetId, minL1Amount.byteLength, ...minL1Amount, promisedAmount.byteLength, ...promisedAmount);
        const recipientEncoding = getAddressEncoding(params.l1Recipient, params.toL1ChainType);
        const recipient = encodeAddress(params.l1Recipient, recipientEncoding);
        results.push(recipient.byteLength, ...recipient);
        const senderEncoding = getAddressEncoding(params.l1Sender, params.fromL1ChainType);
        const sender = encodeAddress(params.l1Sender, senderEncoding);
        results.push(...hexToUint8Array(senderEncoding), sender.byteLength, ...sender);
        if (params.slippageBips) {
            const slippage = hexToUint8Array(params.slippageBips.toString(16));
            results.push(slippage.byteLength, ...slippage);
        }
        else {
            results.push(0);
        }
        params.affiliates.forEach((affiliate) => {
            const affiliateId = hexToUint8Array(affiliate.affiliateId);
            if (affiliateId.byteLength !== 20) {
                throw new Error('Affiliate ID must be 20 bytes long hex string');
            }
            if (affiliate.bips < 0 || affiliate.bips > 10000) {
                throw new Error('Affiliate  BIPS must be between 0 and 10000');
            }
            results.push(...affiliateId);
            if (affiliate.bips > 0) {
                const bips = hexToUint8Array(affiliate.bips.toString(16));
                results.push(bips.byteLength, ...bips);
            }
            else {
                results.push(0);
            }
        });
    }
    else {
        const baseRecipient = hexToUint8Array(params.baseRecipient);
        results.push(0, baseRecipient.byteLength, ...baseRecipient);
    }
    return new Uint8Array(results);
};
